import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SubCategoryActionTypeWrapper = styled.div`
  ${typographyV2.titleSm};
  color: var(--text-soft);
  margin-bottom: 10px;
`;

export const Title = styled.div`
  ${typographyV2.titleLg};
  color: var(--text-default);
`;

export const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
